import CustomOptionsActionTypes from '../actionTypes/CustomOptionsActionTypes';

const getCustomOptionsAction = (payload) => ({
    type: CustomOptionsActionTypes.CUSTOM_OPTIONS_GET_REQUEST,
    payload,
});

const customOptionsOnChange = (payload) => ({
    type: CustomOptionsActionTypes.CUSTOM_OPTIONS_ONCHANGE,
    payload,
});

export default {
    getCustomOptionsAction,
    customOptionsOnChange,
};
